import api from "../service/documento.service";
import * as types from "./documento.actionTypes";
import { takeEvery, call, put, select } from "redux-saga/effects";
import documentoActions from './documento.actions';

export default workSaga;

function* workSaga() {
  yield takeEvery(types.GET_ANEXO, getAnexo);
}

function* getAnexo(action) {
  const { payload } = action;
  const result = yield call(api.getTipoAnexo, payload);

  let anexoCustomizado = result.data.filter(item => {
    return item.TipoAnexo.Customizado == true;
  });

  let anexo = result.data.filter(item => {
    return item.TipoAnexo.Customizado == false;
  });

  yield put(documentoActions.setAnexo(anexo));
  yield put(documentoActions.setAnexoCustomizado(anexoCustomizado));
}
